// extracted by mini-css-extract-plugin
export var activeDot = "_3y-c";
export var buttonContainer = "_3y-9";
export var channelButton = "_3y-a";
export var clickable = "_3y-d";
export var content = "_3y-0";
export var contentFull = "_3y-2";
export var contentThird = "_3y-1";
export var contentWrapper = "_3y-7";
export var description = "_3y-5";
export var heightShort = "_3y-f";
export var image = "_3y-3";
export var imageContainer = "_3y-4";
export var selectButton = "_3y-e";
export var spinnerContainer = "_3y-b";
export var titleContent = "_3y-8";
export var titleWrapper = "_3y-6";